import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=4fb0c24e&scoped=true&"
import script from "./TotalSales.vue?vue&type=script&lang=ts&"
export * from "./TotalSales.vue?vue&type=script&lang=ts&"
import style0 from "./TotalSales.vue?vue&type=style&index=0&id=4fb0c24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0c24e",
  null
  
)

export default component.exports